/**
 * Created by smallking on 2019/1/28.
 */
export default {
  // 加密函数
  compile(code) {
    let monyer = new Array(); let i, s;
    for (i = 0; i < code.length; i++)
      monyer += "\\" + code.charCodeAt(i).toString(8);
    return monyer;
  },
  uncompile(code) {
    let monyer = new Array(); let i;
    let s = code.split("\\");
    for (i = 1; i < s.length; i++)
      monyer += String.fromCharCode(parseInt(s[i], 8));
    return monyer;
  },
  $encrypt(obj)
  {
    if (typeof obj !== 'string') return null;
    return this.compile(obj);
  },
  $decrypt(obj){
    if (typeof obj !== 'string') return null;
    return this.uncompile(obj);
  },

  // 加密函数
  compile2(code) {
    let c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for (let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return encodeURIComponent(c);
  },
  uncompile2(code)
  {
    code = decodeURIComponent(code);
    let c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for (let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
  },
  $encrypt2(obj)
  {
    if (typeof obj !== 'string') return null;
    return this.compile2(obj);
  },
  $decrypt2(obj){
    if (typeof obj !== 'string') return null;
    return this.uncompile2(obj);
  }
}



// WEBPACK FOOTER //
// ./src/config/myCrypt.js